import { Component, ViewEncapsulation } from '@angular/core';
import type { OnInit } from '@angular/core';
import { Platform, IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

@Component({
    'selector': 'app-settings',
    'templateUrl': './settings.page.html',
    'styleUrls': ['./settings.page.scss'],
    'encapsulation': ViewEncapsulation.None,
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule, RouterModule]
})
export class SettingsPage implements OnInit {
    public onDevice = false;

    constructor(private platform: Platform, private router: Router) {
    }

    ngOnInit() {
        // Changing channels must be done on a phone.
        // Don't show the channels option if running on a desktop machine
        this.onDevice = this.platform.is('cordova');
    }

    public onChannelsClick(): void {
        this.router.navigateByUrl('/channels');
    }

    public onDocumentsClick(): void {
        this.router.navigateByUrl('/documents');
    }

    public onCacheCredsClick(): void {
        this.router.navigateByUrl('/cacheCreds');
    }

    public onPricesClick(): void {
        this.router.navigateByUrl('/prices');
    }

    public onSkuActionsClick(): void {
        this.router.navigateByUrl('/skuActions');
    }

    public onSmsFromNumbersClick(): void {
        this.router.navigateByUrl('/smsFromNumbers');
    }

    public onImportClick(): void {
        this.router.navigateByUrl('/import');
    }

    public onExportClick(): void {
        this.router.navigateByUrl('/export');
    }
}
